module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/icon-play_545fd46.png";